import * as Yup from 'yup';

import { getI18nErrorMessage } from 'i18n';

export const NOTES_VALIDATION_SCHEMA = Yup.string()
  .max(500, ({ max }) => getI18nErrorMessage('error.notes.maxLength', { max }))
  .nullable();
